import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { LiveNotificationListItem } from 'src/components/LiveNotificationsPage/LiveNotificationsListItem/LiveNotificationListItem';
import { LiveNotificationForm } from 'src/components/LiveNotificationsPage/LiveNotificationForm/LiveNotificationForm';
import { LiveNotificationsModelType } from 'src/api/config/live_notifications/get_live_notifications';
import {
    ColumnOneOfTwo,
    MainContent,
    TwoColumnResponsiveContentReverse,
} from 'src/domains/layouts/shared/layout/Layout.style';
import { ListContainer } from 'src/domains/layouts/shared/cms/list/List.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const LiveNotificationsPage = observer(() => {
    const { liveNotificationsState } = useAppStateContext();
    const { isLoading, liveNotificationsSorted } = liveNotificationsState;
    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <ListContainer
                        areLoading={isLoading}
                        data-test='live-notification-list'
                    >
                        <Loader isActive={isLoading} />
                        {liveNotificationsSorted.map((liveNotification: LiveNotificationsModelType) => {
                            return (
                                <LiveNotificationListItem
                                    key={liveNotification.id}
                                    liveNotificationsState={liveNotificationsState}
                                    id={liveNotification.id}
                                />
                            );
                        })}
                    </ListContainer>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    <LiveNotificationForm />
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});
